import MoveClientController from '../sites/move_client_controller'
import { jsRequest } from '@react/helpers/fetch'

export default class extends MoveClientController {

  connect() {
    this.destination = this.currentDestination()
  }

  reload() {
    const destination = this.currentDestination()
    if (destination === this.destination) return

    this.destination = destination
    const [siteId, parentId] = destination.split('-')
    const url = new URL(this.data.get('path'), location.origin)
    if (siteId)   url.searchParams.set('material[site_id]', siteId)
    if (parentId) url.searchParams.set('material[parent_id]', parentId)
    jsRequest(url)
  }

  currentDestination() {
    const value = name => this.element.querySelector(`[name="material[${name}]"]`)?.value || ''
    return `${value('site_id')}-${value('parent_id')}`
  }
}
